import React from "react";
import "./common.css";

const FamilyMeals = () => {
  return (
    <div className="insta-root">
      <div className="insta-card">

        {/* Header */}
        <div className="insta-header">
          <div className="insta-badge">Family BOGO Meal</div>
          <h1 className="insta-title">
            Loaded Potato Bake, Berry Parfaits & Sparkling Cooler
          </h1>
          <p className="insta-subtitle">
            One full family dinner created entirely from Publix BOGO deals.
          </p>
        </div>

        {/* MAIN MEAL */}
        <div className="insta-section">
          <h2 className="insta-section-title">🥘 Loaded Cheesy Bacon Potato & Veggie Bake</h2>

          <p><strong>Serves:</strong> 4–6</p>

          <h3 className="insta-section-title">BOGO Items Used</h3>
          <ul className="insta-chip-list">
            <li className="insta-chip">Ore-Ida Potatoes</li>
            <li className="insta-chip">Birds Eye Vegetables</li>
            <li className="insta-chip">Cabot / Kraft Shredded Cheese</li>
            <li className="insta-chip">Oscar Mayer / Hormel Bacon</li>
            <li className="insta-chip">Daisy Sour Cream</li>
            <li className="insta-chip">Campbell’s Cream Soup</li>
            <li className="insta-chip">Land O Lakes Butter</li>
            <li className="insta-chip">Spice Islands Seasonings</li>
            <li className="insta-chip">Swanson Broth (optional)</li>
          </ul>

          <h3 className="insta-section-title">Ingredients</h3>
          <ul className="insta-list">
            <li>1 bag Ore-Ida Potatoes (28–32 oz)</li>
            <li>2 cups Birds Eye Vegetables</li>
            <li>5–6 slices bacon, chopped</li>
            <li>1½–2 cups shredded cheese</li>
            <li>1 can Campbell’s Cream Soup</li>
            <li>¼–½ cup Daisy Sour Cream</li>
            <li>2 tbsp melted butter</li>
            <li>¼ cup Swanson Broth (optional)</li>
            <li>1–2 tsp Spice Islands garlic/onion powder</li>
            <li>Salt & pepper</li>
          </ul>

          <h3 className="insta-section-title">Instructions</h3>

          <div className="insta-step">
            <div className="insta-step-number">1</div>
            <div className="insta-step-body">
              <h3>Cook the bacon</h3>
              <p>Cook until crispy and crumble.</p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">2</div>
            <div className="insta-step-body">
              <h3>Preheat & prep pan</h3>
              <p>Preheat oven to 375°F and grease a 9×13 dish.</p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">3</div>
            <div className="insta-step-body">
              <h3>Build the sauce</h3>
              <p>
                Whisk together cream soup, sour cream, melted butter, optional broth, 
                garlic/onion powder, salt, and pepper.
              </p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">4</div>
            <div className="insta-step-body">
              <h3>Assemble the bake</h3>
              <p>
                Add frozen potatoes, vegetables, and bacon to dish.  
                Pour sauce and toss to coat. Top with cheese.
              </p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">5</div>
            <div className="insta-step-body">
              <h3>Bake</h3>
              <p>
                Cover and bake 25–30 min.  
                Uncover, add more cheese + bacon, bake 10–15 more min.
              </p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">6</div>
            <div className="insta-step-body">
              <h3>Serve</h3>
              <p>
                Optional: add sour cream on top.  
                Serve with La Banderita tortillas or Pillsbury Crescents (both BOGO).
              </p>
            </div>
          </div>
        </div>

        {/* DESSERT */}
        <div className="insta-section">
          <h2 className="insta-section-title">🍓 Blackberry Nilla Parfaits</h2>

          <h3 className="insta-section-title">BOGO Items Used</h3>
          <ul className="insta-chip-list">
            <li className="insta-chip">Blackberries</li>
            <li className="insta-chip">Nilla Wafers</li>
            <li className="insta-chip">Reddi Wip</li>
            <li className="insta-chip">Chobani Greek Yogurt</li>
            <li className="insta-chip">Sun-Maid Raisins (optional)</li>
          </ul>

          <h3 className="insta-section-title">Ingredients</h3>
          <ul className="insta-list">
            <li>1–2 cups blackberries</li>
            <li>Crushed Nilla wafers</li>
            <li>Reddi Wip OR Greek yogurt</li>
            <li>2–3 tbsp raisins (optional)</li>
          </ul>

          <h3 className="insta-section-title">Instructions</h3>
          <div className="insta-step">
            <div className="insta-step-number">1</div>
            <div className="insta-step-body">
              <h3>Build layers</h3>
              <p>Layer wafers → yogurt/Reddi Wip → berries → repeat.</p>
            </div>
          </div>
        </div>

        {/* DRINK */}
        <div className="insta-section">
          <h2 className="insta-section-title">🥤 Sparkling Cranberry Cooler</h2>

          <h3 className="insta-section-title">BOGO Items Used</h3>
          <ul className="insta-chip-list">
            <li className="insta-chip">Ocean Spray Juice Cocktail</li>
            <li className="insta-chip">Lacroix Sparkling Water</li>
            <li className="insta-chip">Vita Coco (optional)</li>
          </ul>

          <h3 className="insta-section-title">Ingredients</h3>
          <ul className="insta-list">
            <li>2 cups Ocean Spray juice</li>
            <li>2 cups Lacroix sparkling water</li>
            <li>½ cup Vita Coco (optional)</li>
            <li>Ice</li>
          </ul>

          <h3 className="insta-section-title">Instructions</h3>
          <div className="insta-step">
            <div className="insta-step-number">1</div>
            <div className="insta-step-body">
              <h3>Mix</h3>
              <p>Combine all liquids, stir gently, pour over ice.</p>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="insta-footer">
          <p className="insta-footer-text">
            Built with <span>🧠 Xpenze</span> — turn BOGOs into full meals.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FamilyMeals;
